import React, { useEffect } from 'react'
import Select from '@material-ui/core/Select'
import { SelectProps } from '@material-ui/core/Select/Select'
import { primaryBlue } from '../../styles/material-ui-theme-v2'
import { ReactComponent as SelectArrowIcon } from '../../assets/v3/icons/select-arrow.svg'
import { getWidthOfText } from '../YumManualEntryForm/YumManualEntryForm'
import { Input } from '@material-ui/core'
import { isRtl } from '../../i18nInit'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  select: {
    padding: '0 8px',
    borderRadius: '8px !important',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 600,
    height: '30px',
    lineHeight: '30px',
  },
}))

export default function YumSmallSelect({ children, ...props }: SelectProps) {
  const classes = useStyles()
  const [width, setWidth] = React.useState(50)

  const updateTextSize = () => {
    // Flatten children array to handle nested arrays
    const flattenChildren = (children: any[]): any[] => {
      return children.reduce((acc, child) => {
        if (Array.isArray(child)) {
          return acc.concat(flattenChildren(child))
        } else if (child && child.props) {
          return acc.concat(child)
        }
        return acc
      }, [])
    }

    const flatChildren = flattenChildren(children || [])

    // @ts-ignore
    const text = flatChildren.find((c: { props: { value: any } }) => c?.props?.value === props.value)?.props?.children
    if (text) {
      const newWidth = getWidthOfText(text, '600', '14px')
      setWidth(newWidth)
    }
  }

  useEffect(() => {
    updateTextSize()
  }, [props.value, children])

  /*componentDidUpdate(prevProps: Readonly<SelectProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (props.value !== prevProps.value) {
      updateTextSize()
    }
  }*/

  const onChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    /*// @ts-ignore
    const text = event.target.options[event.target.selectedIndex].text
    console.log('YumSmallSelect onChange', text)
    if (text) setWidth(getWidthOfText(text, '700', '10px'))*/
    // @ts-ignore
    if (props.onChange) props.onChange(event)
  }

  const outlined = props.variant === 'outlined'

  return (
    <Select
      {...props}
      onChange={onChange}
      native
      IconComponent={(props) => (
        <SelectArrowIcon
          {...props}
          style={{
            top: 'auto',
            left: isRtl ? '11px' : 'auto',
            right: isRtl ? 'auto' : '11px',
            color: outlined ? primaryBlue : 'white',
          }}
        />
      )}
      style={{
        ...props.style,
        width: width + 39 + 'px',
        maxWidth: '100%',
        padding: isRtl ? '0 24px 0 8px !important' : '0 8px 0 24px !important',
      }}
      inputProps={{
        className: classes.select,
        style: {
          paddingRight: isRtl ? 10 : 24,
          paddingLeft: isRtl ? 24 : 10,
        },
      }}
      input={<Input />}
      disableUnderline
    >
      {children}
    </Select>
  )
}
